import { useStore } from '../../store/useStore';
import { useEffect, useState } from 'react';

export const PlayerStatus = () => {
    const room = useStore((state) => state.room);
    const theme = useStore((state) => state.theme);
    const [hp, setHp] = useState(100);
    const [maxHp, setMaxHp] = useState(100);

    useEffect(() => {
        if (!room) return;

        const sessionId = room.sessionId;
        const player = room.state.players.get(sessionId);

        if (player) {
            // Initial set
            setHp(player.hp);
            setMaxHp(player.maxHp);

            // Listen for changes on this specific player object
            // interactive schema usage
            const cleanup = player.listen("hp", (newHp: number) => {
                setHp(newHp);
            });

            // We might want to listen to maxHp too if it changes
            // For now assuming static maxHp after init or we'd need another listener

            return () => {
                cleanup();
            };
        }
    }, [room]); // Re-run if room changes (connect/disconnect)

    const hpRatio = Math.max(0, Math.min(1, hp / maxHp));

    return (
        <div style={{
            position: 'absolute',
            top: '20px',
            left: '20px',
            display: 'flex',
            flexDirection: 'column',
            gap: '10px',
            fontFamily: theme === 'cyberpunk' ? 'Orbitron, sans-serif' : 'Cinzel, serif',
            color: theme === 'cyberpunk' ? '#00f3ff' : '#f0e6d2',
            textShadow: '0 0 5px #000'
        }}>
            <div style={{ fontSize: '1.2em', fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: '10px' }}>
                <div style={{
                    width: '40px', height: '40px',
                    borderRadius: '50%',
                    border: `2px solid ${theme === 'cyberpunk' ? '#00f3ff' : '#8b4513'}`,
                    overflow: 'hidden',
                    background: '#000'
                }}>
                    {/* Avatar Placeholder */}
                    <div style={{ width: '100%', height: '100%', background: theme === 'cyberpunk' ? 'linear-gradient(45deg, #f0f, #0ff)' : 'linear-gradient(45deg, #8b4513, #cd853f)' }} />
                </div>
                <span>PLAYER</span>
            </div>

            {/* HP Bar */}
            <div style={{
                width: '250px',
                height: '24px',
                background: 'rgba(0,0,0,0.6)',
                border: `2px solid ${theme === 'cyberpunk' ? '#fff' : '#5d4037'}`,
                borderRadius: '12px',
                position: 'relative',
                overflow: 'hidden'
            }}>
                <div style={{
                    width: `${hpRatio * 100}%`,
                    height: '100%',
                    background: theme === 'cyberpunk'
                        ? 'linear-gradient(90deg, #ff0055, #ff5500)'
                        : 'linear-gradient(90deg, #8b0000, #ff4500)',
                    transition: 'width 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                    boxShadow: '0 0 10px rgba(255,0,0,0.5)'
                }} />

                <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '12px',
                    fontWeight: 'bold',
                    textShadow: '1px 1px 2px #000'
                }}>
                    {Math.round(hp)} / {maxHp}
                </div>
            </div>

            {/* XP / Level Placeholder */}
            <div style={{ fontSize: '0.9em', opacity: 0.8 }}>
                Level 1 Warrior
            </div>
        </div>
    );
};
